import { Alert } from "react-bootstrap";
import { useAsyncFn } from "react-use";
import repository from "./LeaveRepository";
import LeaveDetailGrid from "./LeaveDetailGrid";
import { LeaveContext } from "./LeaveContext";
import { useContext, useState } from "react";
import AuthDialog from "../../../Component/dialog/AuthDialog";

const LeaveDetailView = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [dataSource, setDataSource] = useContext(LeaveContext);
  const [id, setId] = useState();
  const [deleteState, onDeleteRow] = useAsyncFn(async (value) => {
    setIsOpen(false);
    const data = await repository.deleteLeave(value);
    setDataSource((prevData) => prevData.filter((it) => it.id !== data.id));
  }, []);

  return (
    <div>
      {isOpen ? (
        <AuthDialog
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          onAuthenticated={onDeleteRow}
          value={id}
        />
      ) : null}

      {deleteState.error ? <Alert>{deleteState.error.message}</Alert> : null}

      <LeaveDetailGrid
        dataSource={dataSource}
        onDeleteRow={(id) => {
          setId(id);
          setIsOpen(true);
        }}
      />
    </div>
  );
};

export default LeaveDetailView;
